import { render, staticRenderFns } from "./ModalGardenhotels.vue?vue&type=template&id=7560b3c6&scoped=true&"
import script from "./ModalGardenhotels.vue?vue&type=script&lang=ts&"
export * from "./ModalGardenhotels.vue?vue&type=script&lang=ts&"
import style0 from "./ModalGardenhotels.vue?vue&type=style&index=0&id=7560b3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560b3c6",
  null
  
)

export default component.exports